import { defineField, defineType } from "sanity";

export default defineType({
  name: "careTeam",
  title: "Care Team",
  type: "document",
  fields: [
    defineField({
      name: "name",
      title: "Name",
      type: "string"
    }),
    defineField({
      name: "slug",
      title: "Slug",
      type: "slug",
      options: {
        source: "name",
        maxLength: 96
      }
    }),
    defineField({
      name: "image",
      title: "Profile Picture",
      description: "Used for care team overview",
      type: "image",
      options: {
        hotspot: true
      }
    }),
    defineField({
      name: "portrait",
      title: "Portrait",
      description: "Used for care team detail page",
      type: "image",
      options: {
        hotspot: true
      }
    }),
    defineField({
      name: "description",
      title: "Description",
      type: "string"
    }),
    defineField({
      name: "lwd",
      title: "Lives with Diabetes",
      type: "boolean"
    }),
    defineField({
      name: "title",
      title: "Title",
      type: "string"
    }),
    defineField({
      name: "byline",
      title: "Byline",
      type: "string",
      description: "Used for landingpages"
    }),
    defineField({
      name: "aboutMe",
      title: "About me",
      type: "simpleBlocContent"
    }),
    defineField({
      name: "certificationsAndAwards",
      title: "Certifications and Awards",
      type: "simpleBlocContent"
    }),
    defineField({
      name: "dcsReason",
      title: "I became a DCS because...",
      type: "simpleBlocContent"
    }),
    defineField({
      name: "funFacts",
      title: "Fun Facts",
      type: "simpleBlocContent"
    }),
    defineField({
      name: "userId",
      title: "User ID",
      description: "ID of user on backend",
      type: "string",
      hidden: true
    }),
    defineField({
      name: "userIds",
      title: "User IDs",
      description: "DEV, QA, and PROD IDs of user on backend",
      type: "array",
      of: [{ type: "string" }]
    })
  ],
  preview: {
    select: {
      title: "name",
      media: "image"
    }
  }
});
